import { Component, OnInit, ViewChild,ViewChildren, QueryList, Input, Output, EventEmitter } from '@angular/core';
import { ModalDirective } from 'ng-uikit-pro-standard/lib/free/modals/modal.directive';
import { GraphQLClient } from 'src/app/shared/services/graph-qlclient.service';
import { FormGroup, Validators, FormControl, FormBuilder } from '@angular/forms';
import { SecurityService } from 'src/app/shared/services/security.service';
import { ConsoleService } from 'src/app/shared/services/console.service';
import { ModalSeleccionarClienteComponent } from 'src/app/views/shared/modal-seleccionar-cliente/modal-seleccionar-cliente.component';
import { ModalSeleccionarClienteTiposComponent } from 'src/app/views/shared/modal-seleccionar-cliente-tipos/modal-seleccionar-cliente-tipos.component';
import { ModalSeleccionarProductoComponent } from 'src/app/views/shared/modal-seleccionar-producto/modal-seleccionar-producto.component';
import { FormatoProductosService } from 'src/app/services/formato-productos.service';
import { MDBDatePickerComponent, ToastService } from 'ng-uikit-pro-standard';
import gql from 'graphql-tag';
import { MessageRendererService } from 'src/app/services/message-renderer.service';
import { debounceTime, filter } from 'rxjs/operators';
import { FormValidatorsService } from 'src/app/shared/services/form-validators.service';
import { ModalShowClientesComponent } from '../modal-show-clientes/modal-show-clientes.component';
import { unidad_negocio } from 'src/app/shared/object/unidad_negocio.model';
import { QueryResult } from 'src/app/shared/object/queryResult.model';
import { ProductoService } from 'src/app/services/producto.service';

type MODE = 'ADD' | 'EDIT' | 'VIEW'

@Component({
  selector: 'app-modal-addedit-combo',
  templateUrl: './modal-addedit-combo.component.html',
  styleUrls: ['./modal-addedit-combo.component.scss'],
  providers: [SecurityService],
})
export class ModalAddeditComboComponent implements OnInit {

  // Outputs
  @Output() onSuccess: EventEmitter<any> = new EventEmitter<any>();
  @Input() optionsUnidadesDeNegocio: unidad_negocio[] = []
  @Input() permiteUnidadNegocio: any = []

  // Modales
  @ViewChild('agregarCombo', { static: true }) modalAgregarDescuento: ModalDirective
  @ViewChild(ModalSeleccionarClienteComponent, { static: true }) modalSeleccionarCliente: ModalSeleccionarClienteComponent
  @ViewChild(ModalSeleccionarClienteTiposComponent, { static: true }) modalSeleccionarClientesTipos: ModalSeleccionarClienteTiposComponent
  @ViewChildren(ModalSeleccionarProductoComponent) modalSeleccionarProducto: QueryList<ModalSeleccionarProductoComponent>
  @ViewChild('datePickerInicio', { static: true }) datePickerInicio: MDBDatePickerComponent
  @ViewChild('datePickerFinal', { static: true }) datePickerFinal: MDBDatePickerComponent
  @ViewChild(ModalShowClientesComponent, { static: true }) modalShowClientes: ModalShowClientesComponent

  // Form
  formDetails: FormGroup
  formHeader: FormGroup

  readonly MODAL_SEL_PROD_COMBO = 'MODAL_SEL_PROD_COMBO'


  // Constants
  readonly TIPO_CLIENTE: String = `_CLIENTE_`
  readonly TIPO_TIPO_CLIENTE: String = `_TIPO_CLIENTE_`

  // Data &  Tmp
  private codigoCombo: Number = -1
  private rutEmpresa: Number
  private sucursalEmpresa: Number
  listaProductosCombo: any = []
  optionsFormato: any = []
  optionsUndMedida: any = []
  private loading: boolean = false
  private loaded: boolean = false
  defaultUnidadNegocio: number = null
  mode: MODE

  // clienteSeleccionado: any = null
  clientesSeleccionados: Array<any> = null
  clientesSeleccionadosFormatted: String = null
  tiposClientesSeleccionados: any = null
  tiposClientesSeleccionadosFormatted: String = null
  productoSeleccionado: any = null

  // Utils
  private log: any

  get modalCombo() {
    return this.modalSeleccionarProducto.filter(mod => mod.origen === this.MODAL_SEL_PROD_COMBO)[0]
  }


  constructor(
    private gqlclient: GraphQLClient,
    private accesolocalstorage: SecurityService,
    private fb: FormBuilder,
    private clog: ConsoleService,
    private formatoProductoService: FormatoProductosService,
    private toastrService: ToastService,
    private messageRendererService: MessageRendererService,
    private formValidatorsService: FormValidatorsService,
    private productoService: ProductoService
  ) {
    this.log = this.clog.log('MODAL-COMBOS')
  }

  ngOnInit() {
    this.rutEmpresa = this.accesolocalstorage.getRutEmpresa()
    this.sucursalEmpresa = this.accesolocalstorage.getSucursalCodigo()
    this.createForms()
    this.formChangesSubscriptions()
  }

  trackByProductoCombo(index: number, item: any) {
    return item && item.producto_codigo != null ? item.producto_codigo : (item && item.sku ? item.sku : index);
  }

  /********* SHOW/HIDE *********/
  show(mode: MODE) {
    this.mode = mode
    if (mode === 'ADD') {
      this.codigoCombo = -1

      // Set unidad_negocio_codigo validator
      this.formHeader.get("unidad_negocio_codigo").enable()
      this.formHeader.get('unidad_negocio_codigo').clearValidators()
      if (this.permiteUnidadNegocio) {
        this.formHeader.get('unidad_negocio_codigo').setValidators([Validators.required])
      }
      this.formHeader.get('unidad_negocio_codigo').updateValueAndValidity()

      this.reset()
    }
    this.modalAgregarDescuento.show();
  }

  reset() {
    this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
    this.datePickerInicio.clearDate()
    this.datePickerFinal.clearDate()

    this.resetFormHeader()
    this.resetFormDetails()
    this.resetListaCombos()
  }

  resetFormHeader() {
    this.formHeader.reset()
    this.formHeader.markAsPristine()
    this.formHeader.markAsUntouched()

    this.formHeader.get("buscarPor").setValue(this.TIPO_CLIENTE)
    this.formHeader.get("clienteOrTipos").setValue(null)
    this.formHeader.get("activo").setValue(false)
    this.formHeader.get("fechaInicio").setValue('')
    this.formHeader.get("fechaFin").setValue('')
    this.formHeader.get("codigoProductoNuevo").setValue('')
    this.formHeader.get("precio").setValue(null)
    this.formHeader.get("descripcion").setValue('')
    this.formHeader.get("unidad_negocio_codigo").setValue(null)

    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
    this.tiposClientesSeleccionados = null
    this.tiposClientesSeleccionadosFormatted = null
  }

  resetFormDetails() {
    this.formDetails.reset()
    this.formDetails.markAsPristine()
    this.formDetails.markAsUntouched()
    this.formDetails.get("codigoProductoItem").setValue('')
    this.formDetails.get("formato").setValue(null)
    this.formDetails.get("cantidad").setValue(null)

    this.optionsFormato = []
    this.productoSeleccionado = null
  }

  resetListaCombos() {
    this.listaProductosCombo = []
  }

  hide() {
    this.modalAgregarDescuento.hide();
  }
  /********* SHOW/HIDE *********/

  /********* FORMS *********/
  createForms() {
    this.formHeader = this.fb.group({
      buscarPor: [this.TIPO_CLIENTE, [Validators.required]],
      clienteOrTipos: [null, [Validators.required]],
      activo: [false],
      fechaInicio: ['', [Validators.required]],
      fechaFin: ['', [Validators.required]],
      codigoProductoNuevo: ['', [Validators.required, Validators.min(1)]],
      precio: [null, [Validators.required, Validators.min(1)]],
      descripcion: ['', [Validators.required]],
      unidad_negocio_codigo: [null, []]
    });
    this.formDetails = this.fb.group({
      codigoProductoItem: ['', [Validators.required, Validators.min(1)]],
      formato: [null, [Validators.required]],
      cantidad: [null, [Validators.required, Validators.min(1)]],
    });
  }

  formChangesSubscriptions() {
    this.formHeader.get("buscarPor").valueChanges.subscribe(buscarPor => {
      this.limpiarBuscarPorCliente()
      this.limpiarBuscarPorTiposClientes()
      this.modalSeleccionarCliente.clearClientesSeleccionadosFromOutside()
    })

    // this.formDetails.get("codigoProductoItem").valueChanges
    //   .pipe(filter(Boolean), debounceTime(1000))
    //   .subscribe((codigo: string) => {
    //     this.log('codigoProductoItem valueChanges', codigo)
    //     this.modalSeleccionarProducto.searchBySKU(codigo)
    //   })

    this.formDetails.get("codigoProductoItem").valueChanges
    .pipe(filter(Boolean))
    .subscribe((codProduct: string) => {
      this.modalCombo.searchByCodeProduct(codProduct)
    })


    this.formHeader.get("unidad_negocio_codigo").valueChanges
      .subscribe((unidad_negocio_codigo: number) => {
        this.defaultUnidadNegocio = unidad_negocio_codigo
      })
  }
  /********* FORMS *********/

  /********* MODALS *********/
  limpiarBuscarPorCliente() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.clientesSeleccionadosFormatted = null
  }

  limpiarBuscarPorTiposClientes() {
    this.tiposClientesSeleccionados = null
    this.tiposClientesSeleccionadosFormatted = null
  }

  limpiarDataSeleccionada() {
    // this.clienteSeleccionado = null
    this.clientesSeleccionados = null
    this.tiposClientesSeleccionados = null
  }

  abrirModalSeleccion() {
    if (this.formHeader.get('buscarPor').value === this.TIPO_CLIENTE)
      this.abrirModalSeleccionarCliente()
    else if (this.formHeader.get('buscarPor').value === this.TIPO_TIPO_CLIENTE)
      this.abrirModalSeleccionarClientesTipos()
  }

  abrirModalSeleccionarCliente() {
    this.modalSeleccionarCliente.show()
  }

  abrirModalSeleccionarClienteSeleccionados() {
    this.modalSeleccionarCliente.showSelected({
      paginateLocally: true,
      allowUncheckSelected: this.mode === 'EDIT' || this.mode === 'ADD'
    })
  }

  abrirModalSeleccionarTiposClienteSeleccionados() {
    this.modalSeleccionarClientesTipos.showSelected()
  }

  abrirModalSeleccionarClientesTipos() {
    this.modalSeleccionarClientesTipos.show(!this.tiposClientesSeleccionados)
  }

  abrirModalSeleccionarProducto() {
    this.modalCombo.showWithConfig({
      cleanData: true,
      showUnidadDeNegocioIfAllowed: true,
      defaultUnidadNegocio: this.defaultUnidadNegocio
    })
  }

  // remote query for modal selección Producto
  getProductsByUnidadNegocio({ inputParams, callback }) {
    // this.log('inputParams', JSON.stringify(inputParams))
    // {
    //   "empresa_rut": 76150970,
    //   "sku": "",
    //   "descripcion": "",
    //   "tipobusqueda_estado": 1,
    //   "tipobusquedad_afecto_exento": 1,
    //   "familia": [],
    //   "rubro": [],
    //   "paginaActual": 1,
    //   "cantidadRegistrosPorPagina": 10
    // }
    if (this.permiteUnidadNegocio) {
      const innerInputParams = {
        entidad: {
          empresa_rut: inputParams.empresa_rut,
          sku: inputParams.sku,
          descripcion: inputParams.descripcion,
          tipobusqueda_estado: inputParams.tipobusqueda_estado,
          tipobusquedad_afecto_exento: inputParams.tipobusquedad_afecto_exento,
          listaFamilia: inputParams.familia,
          listaRubro: inputParams.rubro,
          unidad_negocio_codigo: inputParams.unidad_negocio_codigo ? inputParams.unidad_negocio_codigo : this.defaultUnidadNegocio
        },
        paginaActual: inputParams.paginaActual,
        cantidadRegistrosPorPagina: inputParams.cantidadRegistrosPorPagina
      }

      this.log('inputParams (Unidad Negocio)', JSON.stringify(inputParams))

      this.productoService.obtenerSegunFiltroProductosUnidadNegocio(innerInputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0))
          return
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))

      })
    } else {
      this.log('inputParams', JSON.stringify(inputParams))
      this.productoService.obtenerSegunFiltroProductos2(inputParams, ({ respuesta, mensajes }) => {
        if (mensajes && mensajes.length > 0) {
          this.messageRendererService.showErrors(mensajes)
          return
        }

        if (!respuesta) {
          callback(new QueryResult(null, 0, 0, 0))
          return
        }
        const { registros, paginaActual, totalPaginas, totalRegistros } = respuesta
        callback(new QueryResult(registros, paginaActual, totalPaginas, totalRegistros))

      })
    }
  }

  // onClienteSeleccionado({ data, origen }) {
  //   this.limpiarDataSeleccionada()
  //   this.clienteSeleccionado = data
  //   this.formHeader.get("clienteOrTipos").setValue(this.clienteSeleccionado)
  // }

  onClienteSeleccionadoMultiple({ data, origen }) {
    this.limpiarDataSeleccionada()
    // this.clienteSeleccionado = data
    this.clientesSeleccionados = data
    this.clientesSeleccionadosFormatted = this.clientesSeleccionados.map(p => p.nombre).join(', ')
    this.formHeader.get("clienteOrTipos").setValue(this.clientesSeleccionadosFormatted)
  }

  onClienteTiposSeleccionado({ data, origen }) {
    this.limpiarDataSeleccionada()
    this.tiposClientesSeleccionados = data
    this.formHeader.get("clienteOrTipos").setValue(this.tiposClientesSeleccionados)
    this.tiposClientesSeleccionadosFormatted = this.tiposClientesSeleccionados.map(p => p.descripcion).join(', ')
  }

  onProductoSeleccionado({ data: _productoSeleccionado, origen }) {
    this.productoSeleccionado = _productoSeleccionado
    this.formDetails.get('codigoProductoItem').setValue(_productoSeleccionado.sku)
    this.formatoProductoService.GetFormatosByCodigo(
      this.rutEmpresa,
      this.productoSeleccionado.codigo,
      ({ mensajes, respuesta }) => {
        this.optionsFormato = respuesta.registros.map(formato => ({ value: formato.formato_codigo, label: formato.formato_nombre, ...formato }))
        this.formValidatorsService.selectDefaultFormatoProducto(this.formDetails.get('formato'), this.optionsFormato)
      }
    )
  }

  onProductoNoEncontrado() {
    this.productoSeleccionado = null
    this.optionsFormato = []
    this.formDetails.get("formato").setValue(null)
  }
  /********* MODALS *********/


  /********* OPERATIONS *********/
  validateAllFormFields(formGroup: FormGroup) {         // {1}
    Object.keys(formGroup.controls).forEach(field => {  // {2}
      const control = formGroup.get(field);             // {3}
      if (control instanceof FormControl) {             // {4}
        control.markAsTouched({ onlySelf: true });
      } else if (control instanceof FormGroup) {        // {5}
        this.validateAllFormFields(control);            // {6}
      }
    });
  }

  agregarItemCombo() {
    this.validateAllFormFields(this.formDetails);
    if (!this.formDetails.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    // Validar unidad de negocio
    if (!this.validateUnidadNegocioNewProduct(this.productoSeleccionado)) {
      this.toastrService.warning('Producto debe tener la misma unidad de negocio');
      return
    }

    const matches = this.listaProductosCombo.filter(prod => prod.producto_codigo === this.productoSeleccionado.codigo).length
    if (matches > 0) {
      this.toastrService.error(`El producto sku ${this.productoSeleccionado.sku} ya está agregado`);
      return
    }

    // nuevo item
    const newProductoCombo: any = {
      producto_codigo: this.productoSeleccionado.codigo,
      empresa_rut: this.productoSeleccionado.empresa_rut,
      sku: this.productoSeleccionado.sku,
      descripcion: this.productoSeleccionado.descripcion,
      formato: this.formDetails.get('formato').value,
      formatoGlosa: this.optionsFormato.filter(opt => opt.value === this.formDetails.get('formato').value)[0].label,
      cantidad: Number(this.formDetails.get('cantidad').value),
      precio_unitario: this.productoSeleccionado.precio_unitario,
      unidad_negocio_codigo: this.productoSeleccionado.unidad_negocio_codigo,
      index: this.listaProductosCombo.length + 1
    }

    // agregar a lista
    this.listaProductosCombo.push(newProductoCombo)
    this.toastrService.success('Registro agregado')
    this.fixAndDisableUnidadNegocio(this.productoSeleccionado)
    this.resetFormDetails()
  }

  validateUnidadNegocioNewProduct({ unidad_negocio_codigo }): Boolean {
    if (!this.defaultUnidadNegocio)
      return true
    return this.defaultUnidadNegocio === unidad_negocio_codigo
  }

  fixAndDisableUnidadNegocio({ unidad_negocio_codigo }) {
    this.defaultUnidadNegocio = unidad_negocio_codigo //this.formHeader.get("unidad_negocio_codigo").value
    this.formHeader.get("unidad_negocio_codigo").setValue(unidad_negocio_codigo)
    this.formHeader.get("unidad_negocio_codigo").disable()
  }

  eliminarItemCombo(index) {
    this.listaProductosCombo = this.listaProductosCombo.filter(item => item.index !== index)
    this.toastrService.warning('Registro eliminado')
    this.checkAndClearDefaultUnidadDeNegocio()
  }

  checkAndClearDefaultUnidadDeNegocio() {
    if (this.listaProductosCombo.length === 0) {
      this.defaultUnidadNegocio = null
      this.formHeader.get("unidad_negocio_codigo").enable()
    }
  }

  guardar() {
    this.validateAllFormFields(this.formHeader);
    if (!this.formHeader.valid) {
      this.toastrService.warning('Favor complete los datos requeridos');
      return
    }

    const esTipoCliente = this.formHeader.get("buscarPor").value === this.TIPO_TIPO_CLIENTE
    if (esTipoCliente) {
      if (!this.tiposClientesSeleccionados || this.tiposClientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese tipos de clientes');
        return
      }
    } else {
      if (!this.clientesSeleccionados || this.clientesSeleccionados.length === 0) {
        this.toastrService.warning('Favor ingrese clientes');
        return
      }
    }

    // const { unidad_negocio_codigo } = this.formHeader.value
    const unidad_negocio_codigo = this.formValidatorsService.obtenerValorFormHeader(this.formHeader, 'unidad_negocio_codigo')
    const combo: any = {
      activo: this.formHeader.get("activo").value,
      codigo: this.codigoCombo,
      descripcion: this.formHeader.get("descripcion").value,
      empresa_rut: Number(this.rutEmpresa),
      fecha_caducidad_combo: this.formHeader.get("fechaFin").value,
      fecha_inicio_combo: this.formHeader.get("fechaInicio").value,
      sku: this.formHeader.get("codigoProductoNuevo").value,
      precio_unitario: Number(this.formHeader.get("precio").value),
      clientesAfectados: [],
      detalleProductos: [],
      unidad_negocio_codigo: this.permiteUnidadNegocio ? unidad_negocio_codigo : null
    }
    if (esTipoCliente) {
      combo.esTipoCliente = true
      combo.tipo_cliente = this.tiposClientesSeleccionados.map(tipo => ({ codigo: tipo.codigo }))
    }
    else {
      combo.clientesAfectados = this.clientesSeleccionados.map(cliente => ({
        producto_codigo: this.codigoCombo,
        empresa_rut: Number(this.rutEmpresa),
        cliente_proveedor_rut: cliente.rut
      }))
    }
    combo.detalleProductos = this.listaProductosCombo.map(producto => ({
      producto_codigo: producto.producto_codigo,
      empresa_rut: producto.empresa_rut,
      combo_producto_codigo: this.codigoCombo,
      combo_formato_codigo: producto.formato,
      cantidad: producto.cantidad,
      unidad_negocio_codigo: producto.unidad_negocio_codigo
    }))

    this.log('variables', JSON.stringify({ entidad: combo }))
    const self = this
    this.gqlclient.mutate(
      {

        mutation: gql`
          mutation($entidad: combo_clientes_detalleDTOInputType) {

            combo_detalle {
              guardarDTO(entidad: $entidad) {
                mensajes
                {
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  activo
                  codigo
                  descripcion
                  sku
                  fecha_caducidad_combo
                  fecha_inicio_combo
                  precio_unitario
                  unidad_negocio_codigo

                  clientesAfectados{
                    producto_codigo
                    empresa_rut
                    cliente_proveedor_rut
                  }
                  detalleProductos{
                    producto_codigo
                    empresa_rut
                    combo_producto_codigo
                    combo_formato_codigo
                    cantidad

                  }
                }
              }
            }
          }
        `,
        variables: {
          entidad: combo
        },
      },
      function (_respuesta) {
        const { mensajes, respuesta } = _respuesta.data.combo_detalle.guardarDTO
        const ok = respuesta !== null
        if (!ok) {
          self.messageRendererService.showErrors(mensajes)
          return
        }
        else {
          self.toastrService.success('Combo guardado')
          self.hide()
          self.onSuccess.emit()
          return
        }
      }
    );
  }

  load(empresa_rut, codigo, allowEdit: boolean = true) {
    this.mode = allowEdit ? 'EDIT' : 'VIEW'
    this.codigoCombo = codigo
    const _variables = {
      empresa_rut,
      codigo
    }

    this.loaded = false
    this.loading = true
    this.formHeader.get("unidad_negocio_codigo").disable()

    const self = this
    this.gqlclient.query(
      {
        query: gql`
          query
            (
              $empresa_rut: Decimal,
              $codigo: Decimal
            )
          {
            producto{
              obtenerSegunFiltroProductosCombo(
                filtro: {
                  exacto:{
                    empresa_rut: $empresa_rut
                    tipobusqueda_estado:3
                    fecha_inicio_combo: "01-01-0001"
                    fecha_caducidad_combo: "01-01-0001"
                    tipo_cliente:[]
                    rut_cliente_multiple:[]
                    codigo: $codigo
                    sku:""
                  }
                }
              )
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  paginaActual
                  cantidadRegistrosPorPagina
                  totalPaginas
                  totalRegistros
                  registros{
                    codigo
                    sku
                    descripcion
                    activo
                    familia_codigo
                    tipo_producto_codigo
                    fecha_caducidad_combo
                    fecha_inicio_combo
                    rubro_codigo
                    precio_unitario_combo
                    unidad_negocio_codigo
                  }
                }
              }
            }

            combo_detalle_cliente
            {
              obtenerSegunFiltro(filtro:{
                exacto:{
                  producto_codigo: $codigo
                  empresa_rut: $empresa_rut
                }
              })
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  registros{
                    producto_codigo
                    empresa_rut
                    cliente_proveedor_rut
                    nombreCliente
                  }
                }
              }
            }

            combo_detalle{
              obtenerSegunFiltro(filtro:{
                exacto:{
                  combo_producto_codigo: $codigo
                  empresa_rut: $empresa_rut
                  combo_formato_codigo: ""
                  producto_codigo:-1
                }
              })
              {
                mensajes{
                  codigo
                  contexto
                  texto
                  tipo
                }
                respuesta{
                  registros{
                    producto_codigo
                    empresa_rut
                  	combo_producto_codigo
                    combo_formato_codigo
                    cantidad
                    descripProducto
                    descripFormato
                    sku
                  }
                }
              }
            }

          }
         `,
        variables: _variables,
        fetchPolicy: 'no-cache',
      },
      function (response) {
        // Header
        const { respuesta: respHeader } = response.data.producto.obtenerSegunFiltroProductosCombo
        const { registros: headerData } = respHeader

        self.formHeader.get('activo').setValue(headerData[0].activo)//: [0],
        self.formHeader.get('fechaInicio').setValue(headerData[0].fecha_inicio_combo)//: ['', [Validators.required]],
        self.formHeader.get('fechaFin').setValue(headerData[0].fecha_caducidad_combo)//: ['', [Validators.required]],
        self.formHeader.get('codigoProductoNuevo').setValue(headerData[0].sku)//: [0, [Validators.required, Validators.min(1)]],
        self.formHeader.get('precio').setValue(headerData[0].precio_unitario_combo)//: [0, [Validators.required, Validators.min(1)]],
        self.formHeader.get('descripcion').setValue(headerData[0].descripcion)//: ['', [Validators.required]]
        self.formHeader.get('unidad_negocio_codigo').setValue(headerData[0].unidad_negocio_codigo)//: ['', [Validators.required]]

        // Clientes
        const { respuesta: respClientes } = response.data.combo_detalle_cliente.obtenerSegunFiltro
        const { registros: clientsData } = respClientes
        // combo.clientesAfectados = this.clientesSeleccionados.map(cliente => ({
        //   producto_codigo: this.codigoCombo,
        //   empresa_rut: Number(this.rutEmpresa),
        //   cliente_proveedor_rut: cliente.rut
        // }))
        const dataClientes = clientsData.map(cliente => ({
          rut: cliente.cliente_proveedor_rut,
          nombre: cliente.nombreCliente,
          codigo_direccion: cliente.codigo_direccion
        }))
        self.modalSeleccionarCliente.setClientesSeleccionadosFromOutside(dataClientes)
        // self.onClienteSeleccionadoMultiple({ data: dataClientes, origen: null });


        const { mensajes, respuesta: respDetalles } = response.data.combo_detalle.obtenerSegunFiltro
        const { registros: productsData, paginaActual, totalPaginas, totalRegistros } = respDetalles
        // self.paginationContext.RecordsCount = totalRegistros
        // self.paginationContext.CurrentPage = paginaActual
        // self.paginationContext.PagesCount = totalPaginas

        // Products
        self.listaProductosCombo = productsData.map((producto, index) => ({
          producto_codigo: producto.producto_codigo,
          empresa_rut: producto.empresa_rut,
          sku: producto.sku,
          descripcion: producto.descripProducto,
          formato: producto.combo_formato_codigo,
          formatoGlosa: producto.descripFormato,
          cantidad: producto.cantidad,
          index
        }));

        self.show(self.mode)
      }
    );
  }
  /********* OPERATIONS *********/

  verClientesSeleccionados() {
    this.modalShowClientes.show(this.clientesSeleccionados)
  }

}
